const BaseError = require('make-error').BaseError;

class ConflictError extends BaseError {
    constructor(errorMessage='Another user changed this record.', conflictId, currentDocument) {
        super(errorMessage);
        this.conflictId = conflictId;
        this.currentDocument = currentDocument;
    }
}

module.exports = ConflictError;